import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { useCallback } from 'react';
import { AbvPbmRateAddButton } from './AbvPbmRateAddButton';

export const AbvPbmRateList = ({ lbeId }) => {

  const augRowsReq = useCallback((rowsReq) => {
    rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('lbeId', lbeId));
  }, [lbeId]);

  const augTabButtons = (buttons) => {
    ObjUtils.clearObj(buttons);
    buttons.push(<AbvPbmRateAddButton lbeId={lbeId} />);
  }

  return (
    <EntityList entity="PBM_RATE" augTabButtons={augTabButtons} augRowsReq={augRowsReq} />
  )
}